import { takeLatest } from 'redux-saga/effects';
import {
  getAccessGroupUserListSuccess, getAccessGroupUserListFail,
  getAccessGroupUserDetailsSuccess, getAccessGroupUserDetailsFail
} from './accessGroupUserState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/security/access-groups');
const redirectData = {route:'/console/access-groups', mode: 'list', recordId:0 };
const modelName = 'Access Group Users';
const modelId = 'agu_id';

function* getAccessGroupUserList(data) {
	const { groupId, ...params } = data.payload;
	const childEndpoint = `${groupId}/access-group-users`;
	yield doCrudCall(
		() => crudService.getList(params, childEndpoint ), 
		getAccessGroupUserListSuccess, 
		getAccessGroupUserListFail,
		null, null, LOADING_MSG);
}

function* getAccessGroupUserDetails(data) {
	const { groupId, groupuserId } = data.payload;
	const childEndpoint = `${groupId}/access-group-users`;
	yield doCrudCall(
		() => crudService.getDetails(groupuserId, childEndpoint), 
		getAccessGroupUserDetailsSuccess, 
		getAccessGroupUserDetailsFail,
		null, null, LOADING_MSG);		
}

function* doAccessGroupUserCreate(data){
	const childEndpoint = `${data.payload.agu_group_id}/access-group-users`;
	yield doCrudCall(
		() => crudService.doCreate(data.payload, childEndpoint), 
		getAccessGroupUserDetailsSuccess, 
		getAccessGroupUserDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doAccessGroupUserUpdate(data){
	const childEndpoint = `${data.payload.agu_group_id}/access-group-users`;
	yield doCrudCall(
		() => crudService.doUpdate(data.payload.agu_id, data.payload, childEndpoint), 
		getAccessGroupUserDetailsSuccess, 
		getAccessGroupUserDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doAccessGroupUserDelete(data){
	const childEndpoint = `${data.payload.agu_group_id}/access-group-users`;
	yield doCrudCall(
		() => crudService.doDelete(data.payload.agu_id, childEndpoint), 
		getAccessGroupUserDetailsSuccess, 
		getAccessGroupUserDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* accessGroupUserSaga() {
  yield takeLatest('accessGroupUser/getAccessGroupUserList', getAccessGroupUserList);
  yield takeLatest('accessGroupUser/getAccessGroupUserDetails', getAccessGroupUserDetails);
  yield takeLatest('accessGroupUser/doAccessGroupUserCreate', doAccessGroupUserCreate);
  yield takeLatest('accessGroupUser/doAccessGroupUserUpdate', doAccessGroupUserUpdate);
  yield takeLatest('accessGroupUser/doAccessGroupUserDelete', doAccessGroupUserDelete);  
}

export default accessGroupUserSaga;
